import script from "./DueDiligenceUploadDocPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./DueDiligenceUploadDocPopup.vue?vue&type=script&setup=true&lang=js"

import "./DueDiligenceUploadDocPopup.vue?vue&type=style&index=0&id=39a13ad3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39a13ad3"]])

export default __exports__